import { ExternalLink } from '@/shared/core/components/external-link/external-link.tsx'
import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import '@/teams/portfolio/components/section/home-section/home-content/home-content.scss'

export function HomeContent() {
	const { t } = useTranslation()

	return (
		<div className='home-content' data-testid='home-content'>
			<h1 className='home-content__name'>{t('portfolio.section.home.name')}</h1>
			<p className='home-content__tagline'>
				{t('portfolio.section.home.tagline')}
			</p>
			<p className='home-content__description'>
				{t('portfolio.section.home.descriptionStart')}{' '}
				<ExternalLink
					className='home-content__orange-link'
					href='https://www.orange-business.com/fr/solutions/data-ia-iot/live-intelligence'>
					Orange Business
				</ExternalLink>
				{t('portfolio.section.home.descriptionEnd')}
			</p>
		</div>
	)
}
